// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Luwo","choiceBoxes":"toolbarselects_choiceBoxes__14toc","simpleField":"toolbarselects_simpleField__3IeF9"};